export default {
    DISCONNECTED: 'Falha ao buscar as informações.',
    LOST_SESSION: 'Perda de sessão! A página será recarregada.',
    UNKNOWN: 'Erro desconhecido.'
}
